export const AGB = () => {
  return <>
    <h1>Allgemeine Geschäftsbedingungen des Vereins Rock im Garten e.V. </h1>
    <br />
    <br />
    <strong>§1 Geltung gegenüber Unternehmern und Begriffsdefinitionen </strong>
    <br />
    (1) Die nachfolgenden Allgemeinen Geschäftbedingungen gelten für alle Lieferungen zwischen uns und einem Verbraucher in ihrer zum Zeitpunkt der Bestellung gültigen Fassung.
    <br />
    Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können (§ 13 BGB).
    <br />
    <br />
    <strong>2 Zustandekommen eines Vertrages, Speicherung des Vertragstextes </strong>§
    <br />
    (1) Die folgenden Regelungen über den Vertragsabschluss gelten für Bestellungen über unseren Internetshop auf http://www.rock-im-garten.com .
    <br />
    (2) Im Falle des Vertragsschlusses kommt der Vertrag mit
    <br />
    <br />
    Rock im Garten e.V.  <br />
    Westentor 126a  <br />
    D-38836 Osterwieck OT Rohrsheim  <br />
    Registernummer VR 5615  <br />
    Registergericht Amtsgericht Stendal  <br />
    <br />
    zustande.  <br />
    <br />
    (3) Die Präsentation der Waren in unserem Internetshop stellen kein rechtlich bindendes Vertragsangebot unsererseits dar, sondern sind nur eine unverbindliche Aufforderungen an den Verbraucher, Waren zu bestellen. Mit der Bestellung der gewünschten Ware gibt der Verbraucher ein für ihn verbindliches Angebot auf Abschluss eines Kaufvertrages ab.  <br />
    (4) Bei Eingang einer Bestellung in unserem Internetshop gelten folgende Regelungen: Der Verbraucher gibt ein bindendes Vertragsangebot ab, indem er die in unserem Internetshop vorgesehene Bestellprozedur erfolgreich durchläuft.
    <br /> <br />
    <h2>Die Bestellung erfolgt in folgenden Schritten:</h2>

    1) Auswahl der gewünschten Ware  <br />
    2) Bestätigen durch Anklicken der Buttons „Bestellen“  <br />
    3) Prüfung der Angaben im Warenkorb  <br />
    4) Betätigung des Buttons der gewünschten Bezahlmethode  <br />
    5) Eingabe der Käuferdaten in Popup des Zahlunganbiters (z.B.PayPal)  <br />
    6) Nochmalige Prüfung bzw. Berichtigung der jeweiligen eingegebenen Daten.  <br />
    7) Verbindliche Absendung der Bestellung durch Anklicken des Buttons „kostenpflichtig bestellen“ bzw. „kaufen“  <br />
    <br />
    Der Verbraucher kann vor dem verbindlichen Absenden der Bestellung durch Betätigen der in dem von ihm verwendeten Internet-Browser enthaltenen „Zurück“-Taste nach Kontrolle seiner Angaben wieder zu der Internetseite gelangen, auf der die Angaben des Kunden erfasst werden und Eingabefehler berichtigen bzw. durch Schließen des Internetbrowsers den Bestellvorgang abbrechen. Wir bestätigen den Eingang der Bestellung unmittelbar durch eine automatisch generierte E-Mail („Auftragsbestätigung“). Mit dieser nehmen wir Ihr Angebot an.  <br />
    <br />
    (5) Speicherung des Vertragstextes bei Bestellungen über unseren Internetshop : Wir senden Ihnen die Bestelldaten und unsere AGB per E-Mail zu. Die AGB können Sie jederzeit auch unter http://www.rock-im-garten.com einsehen. Ihre Bestelldaten sind aus Sicherheitsgründen nicht mehr über das Internet zugänglich.
    <br />
    <br />
    <strong>§3 Preise, Versandkosten, Zahlung, Fälligkeit</strong>
    <br />
    (1) Die angegebenen Preise enthalten die gesetzliche Umsatzsteuer und sonstige Preisbestandteile. Hinzu kommen etwaige Versandkosten.
    <br />
    (2) Der Verbraucher hat die Möglichkeit der Zahlung per Vorkasse, PayPal .
    <br />
    (3) Hat der Verbraucher die Zahlung per Vorkasse gewählt, so verpflichtet er sich, den Kaufpreis unverzüglich nach Vertragsschluss zu zahlen.
    <br />
    <br />

    <strong>§4 Lieferung </strong>
    <br />
    (1) Sofern wir dies in der Produktbeschreibung nicht deutlich anders angegeben haben, sind alle von uns angebotenen Artikel sofort versandfertig. Die Lieferung erfolgt hier spätesten innerhalb von 14 Werktagen. Dabei beginnt die Frist für die Lieferung im Falle der Zahlung per Vorkasse am Tag nach Zahlungsauftrag an die mit der Überweisung beauftragte Bank und bei allen anderen Zahlungsarten am Tag nach Vertragsschluss zu laufen. Fällt das Fristende auf einen Samstag, Sonntag oder gesetzlichen Feiertag am Lieferort, so endet die Frist am nächsten Werktag.
    <br />
    (2) Die Gefahr des zufälligen Untergangs und der zufälligen Verschlechterung der verkauften Sache geht auch beim Versendungskauf erst mit der Übergabe der Sache an den Käufer auf diesen über.
    <br />

    <strong> §5 Eigentumsvorbehalt </strong>
    <br />
    Wir behalten uns das Eigentum an der Ware bis zur vollständigen Bezahlung des Kaufpreises vor.
    <br />
    <strong>§ 6 Programmänderungen / Ausfall einzelner Künstler</strong>
    <br />
    (1) Rock im Garten e.V. behält sich Änderungen im Programm, im Ablauf sowie in der Besetzung vor.
    <br />
    (2) Der Ausfall einzelner Bands, Künstler oder Programmpunkte berechtigt nicht zur Minderung des Eintrittspreises oder zum Rücktritt vom Vertrag, sofern die Veranstaltung im Übrigen durchgeführt wird.
    <br />
    <br />

    <strong>§ 7 Absage, Abbruch oder Unterbrechung der Veranstaltung</strong>
    <br />
    (1) Muss die Veranstaltung aus Gründen höherer Gewalt, aufgrund behördlicher Anordnung oder aus Sicherheitsgründen abgesagt, verschoben, unterbrochen oder abgebrochen werden, entscheidet hierüber Rock im Garten e.V.
    <br />
    (2) Im Falle einer vollständigen Absage vor Veranstaltungsbeginn wird der Ticketpreis erstattet. Eine Erstattung von Vorverkaufs-, System- oder Bearbeitungsgebühren erfolgt nur, soweit diese von Rock im Garten e.V. vereinnahmt wurden.
    <br />
    (3) Bei Abbruch oder Unterbrechung nach Veranstaltungsbeginn besteht kein Anspruch auf vollständige oder anteilige Rückerstattung des Ticketpreises, sofern der Abbruch aus Gründen höherer Gewalt oder aus Sicherheitsgründen erfolgt.
    <br />
    <br />

    <strong>§ 8 Höhere Gewalt</strong>
    <br />
    (1) Als höhere Gewalt gelten insbesondere außergewöhnliche und unvorhersehbare Ereignisse, die außerhalb des Einflussbereichs von Rock im Garten e.V. liegen.
    <br />
    (2) Hierzu zählen insbesondere extreme Witterungsverhältnisse (z. B. Sturm, Unwetter, Starkregen, Gewitter), Naturereignisse, behördliche Untersagungen, Gefahrenlagen oder sonstige sicherheitsrelevante Umstände.
    <br />
    <br />

    <strong>§ 9 Haftungsbeschränkung</strong>
    <br />
    Schadensersatzansprüche im Zusammenhang mit der Absage, Änderung, Unterbrechung oder dem Abbruch der Veranstaltung sind ausgeschlossen, soweit Rock im Garten e.V. nicht vorsätzliches oder grob fahrlässiges Verhalten zur Last fällt.
    <br />
    <br />
    <br />
    ****************************************************************************************************
    <br />
    <strong>§10 Widerrufsrecht des Kunden als Verbraucher:</strong>

    <br />
    Widerrufsrecht für Verbraucher
    <br />
    Verbrauchern steht ein Widerrufsrecht nach folgender Maßgabe zu, wobei Verbraucher jede natürliche Person ist, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können:
    <br />

    <h2>Widerrufsbelehrung </h2>

    <h3>Widerrufsrecht</h3>

    Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
    <br />
    Die Widerrufsfrist beträgt vierzehn Tage, ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.
    <br />
    Um Ihr Widerrufsrecht auszuüben, müssen Sie uns
    <br />
    Rock im Garten e.V.  <br />
    Christian Borger  <br />
    Westentor 126a  <br />
    D-38836 Osterwieck OT Rohrsheim  <br />
    E-Mail: info@rock-im-garten.com  <br />
    <br />
    mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
    <br />
    <h3>Widerrufsfolgen</h3>
    <br />
    Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
    <br />
    Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.
    <br />
    Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrages unterrichten, an uns zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von vierzehn Tagen absenden.
    <br />
    Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.
    <br />
    Ende der Widerrufsbelehrung
    <br />
    ****************************************************************************************************

    <strong>§11 Widerrufsformular</strong>

    Muster-Widerrufsformular  <br />
    <br />
    (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)
    <br />
    An :  <br />
    Rock im Garten e.V.  <br />
    Christian Borger  <br />
    Westentor 126a  <br />
    D-38836 Osterwieck OT Rohrsheim  <br />
    E-Mail: info@rock-im-garten.com  <br />
    <br />
    Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)
    <br />
    _____________________________________________________  <br />

    Bestellt am (*)/erhalten am (*) <br />
    <br />
    __________________  <br />
    <br />
    Name des/der Verbraucher(s)  <br />
    <br />
    _____________________________________________________  <br />

    Anschrift des/der Verbraucher(s)  <br />
    <br />
    <br />
    _____________________________________________________  <br />

    Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)  <br />
    <br />
    __________________  <br />

    Datum  <br />
    <br />
    __________________  <br /> <br />

    (*) Unzutreffendes streichen.  <br />
    <br />

    <strong> §12 Gewährleistung </strong>
    <br />
    Es gelten die gesetzlichen Gewährleistungsregelungen.  <br />
    <br />

    <strong> §13 Vertragssprache </strong>

    Als Vertragssprache steht ausschließlich Deutsch zur Verfügung.
    <br /> <br />


    Stand der AGB Mai.2022

  </>
}
